import { LoadingPage } from "~/app/waiting-component";
import { useFeatures } from "~/components/features.context";
import { LegacyPage } from "~/components/legacy-page";

const LegacyPrintView = () => {
  const { featuresLoaded } = useFeatures();

  return featuresLoaded ? (
    <div className="h-screen">
      <LegacyPage />
    </div>
  ) : (
    <LoadingPage />
  );
};

export default LegacyPrintView;
